module.exports = __webpack_public_path__ + "static/media/images.f3140b79.jpg";